// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../rescript/lib/es6/curry.js";
import * as Generic$ApiTypes from "../utils/Generic.bs.js";
import * as Store_PublicCodecs$ApiTypes from "../Store/Store_PublicCodecs.bs.js";
import * as Account_PublicDecoders$ApiTypes from "../Account/Account_PublicDecoders.bs.js";
import * as LegacyShowside_CategoryDecoders$ApiTypes from "./LegacyShowside_CategoryDecoders.bs.js";
import * as LegacyShowside_SettingsDecoders$ApiTypes from "./LegacyShowside_SettingsDecoders.bs.js";

var fromJson = Curry.app(Generic$ApiTypes.Decode.map8, [
      Curry._2(Generic$ApiTypes.Decode.field, "id", Generic$ApiTypes.Decode.string),
      Curry._2(Generic$ApiTypes.Decode.field, "categories", Curry._1(Generic$ApiTypes.Decode.array, LegacyShowside_CategoryDecoders$ApiTypes.fromJson)),
      Curry._2(Generic$ApiTypes.Decode.field, "settings", LegacyShowside_SettingsDecoders$ApiTypes.fromJson),
      Curry._2(Generic$ApiTypes.Decode.field, "transitiveStoreId", Curry._1(Generic$ApiTypes.Decode.nullable, Generic$ApiTypes.Decode.string)),
      Curry._2(Generic$ApiTypes.Decode.field, "transitiveAccount", Curry._1(Generic$ApiTypes.Decode.nullable, Account_PublicDecoders$ApiTypes.Public.fromJson)),
      Generic$ApiTypes.Decode.fieldWithDefault("transitiveStore", Curry._1(Generic$ApiTypes.Decode.nullable, Store_PublicCodecs$ApiTypes.Public.fromJson), undefined),
      Curry._2(Generic$ApiTypes.Decode.field, "accountId", Curry._1(Generic$ApiTypes.Decode.nullable, Generic$ApiTypes.Decode.string)),
      Curry._2(Generic$ApiTypes.Decode.field, "lastModifiedAt", Generic$ApiTypes.Decode.$$float),
      (function (id, categories, settings, transitiveStoreId, transitiveAccount, transitiveStore, accountId, lastModifiedAt) {
          return {
                  id: id,
                  categories: categories,
                  settings: settings,
                  transitiveStoreId: transitiveStoreId,
                  transitiveAccount: transitiveAccount,
                  transitiveStore: transitiveStore,
                  accountId: accountId,
                  lastModifiedAt: lastModifiedAt
                };
        })
    ]);

var Breakpoint2;

export {
  Breakpoint2 ,
  fromJson ,
}
/* fromJson Not a pure module */
